import {
  type AgreementParty,
  downloadAgreementDocument,
} from '@/api/agreements';
import { DocumentOpenButton } from '@/components/DocumentOpenButton';
import { LABEL_CLASS, VALUE_DEFAULT_CLASS } from '@/components/Field';

const LABELS: Record<AgreementParty, string> = {
  customer: 'Customer Agreement',
  dealer: 'Dealer Agreement',
};

export function AgreementDocumentField({
  agreementId,
  party,
  documentId,
}: {
  agreementId: string;
  party: AgreementParty;
  documentId: string;
}) {
  return (
    <div>
      <p className={LABEL_CLASS}>{LABELS[party]}</p>
      <div className="mt-1 flex items-center justify-between gap-2">
        <p className={VALUE_DEFAULT_CLASS}>{documentId}</p>
        <DocumentOpenButton
          documentName={`${party} agreement`}
          load={() => downloadAgreementDocument(agreementId, party)}
        />
      </div>
    </div>
  );
}
